import { PIE, TINTA } from "./medidas"
import { Nota, Renglon, Rotulo } from "./piezas"
import type { Comun, FormatoRegistrado } from "./tipos"

/**
 * El pie de los dos formatos: quién responde, y la nota de la aduana.
 *
 * ⚠ **La nota NO es nuestra y por eso va copiada del PDF, letra por letra.** «DE SER
 * MAS DE 3 CONTENEDORES SE DEBE ENTREGAR COPIA DEL BL» es una instrucción del SENIAT,
 * con sus mayúsculas y sin la tilde que le falta. Corregirle la ortografía a un
 * formato oficial es reescribir un documento que no es de la agencia.
 *
 * ⚠ **La firma no tiene campo.** Ver `Renglon`: se firma a mano, con un bolígrafo,
 * después de imprimir. Poner ahí una caja de texto invita a teclear un nombre donde
 * hace falta una rúbrica — y una rúbrica tecleada no vale nada ante la aduana.
 *
 * ⚠ **`tipo` es `FormatoRegistrado` y no `TipoPlantilla`.** Este bloque son las
 * coordenadas de `PIE`, que sólo existen para los dos formatos del SENIAT: la guía de
 * despacho es papelería nuestra, no se posiciona al punto y tiene su propio pie. Con la
 * unión ancha, `PIE[tipo]` compilaría y daría `undefined` en pantalla.
 */
export function PieResponsable({
  tipo,
  datos,
  onCambio,
}: {
  tipo: FormatoRegistrado
  datos: Comun
  onCambio: (cambio: Partial<Comun>) => void
}) {
  const sitio = PIE[tipo]

  return (
    <>
      <Rotulo x={sitio.responsable} y={sitio.y} tamano={11.2} tinta={TINTA.oscura}>
        Responsable.
      </Rotulo>

      {PIE.lineas.map((linea, indice) => {
        const y = sitio.y + PIE.salto * (indice + 1) + PIE.primera
        if (linea.campo === null) {
          return (
            <Renglon
              key={linea.etiqueta}
              x={sitio.x}
              y={y}
              ancho={PIE.renglon}
              etiqueta={linea.etiqueta}
            />
          )
        }
        const campo = linea.campo
        return (
          <Renglon
            key={linea.etiqueta}
            x={sitio.x}
            y={y}
            ancho={PIE.renglon}
            etiqueta={linea.etiqueta}
            valor={datos.responsable[campo]}
            onCambio={(v) => onCambio({ responsable: { ...datos.responsable, [campo]: v } })}
          />
        )
      })}

      <Nota x={sitio.nota.x} y={sitio.nota.y} lineas={[...sitio.nota.lineas]} />
    </>
  )
}
